<template>
  <div class="row"
  >
    <div v-if="showLoading" class="col-12">
      <loading-panel message="pleaseWait"/>
    </div>
    <div class="w-100"/>
    <div class="col-12 col-md-11">
      <!--META CONFIG-->
      <div
          v-if="metaDataColumns.length && $store.getters.getAssemblyContent($route.params.id).pipeline.vhubPostProcessors && hasRootFile"
          class="mb-3">
        <meta-config
            ref="MetaConfig"
            :meta-data-columns="metaDataColumns"
            :organization-id="$store.getters.getAssemblyOrganization($route.params.id)"
            :teams="teams"
            permission="writeMetaSet"
            @setConfig="setMetaConfig"
        />
      </div>

      <info-panel
          :collapsible="true"
          :initially-collapsed="true"
          class="new-style smaller-title mb-1"
          info-panel-header="Advanced"
          preview-id="assembly-import-config"
      >
        <div slot="info" class="p-2">

          <!--EXPORT GROUPS-->
          <div class="dflex ml-2">
            <label :for="'groups' + $vnode.key" class="container"
            >{{ $t('pipeline.exportGroups') }}
              <input
                  :id="'groups' + $vnode.key"
                  v-model="exportGroups"
                  type="checkbox"
              >
              <span class="checkmark"/>
            </label>
          </div>

          <!--EXPORT PARTS-->
          <div class="dflex ml-2">
            <label :for="'parts' + $vnode.key" class="container"
            >{{ $t('pipeline.exportParts') }}
              <input
                  :id="'parts' + $vnode.key"
                  v-model="exportParts"
                  type="checkbox"
              >
              <span class="checkmark"/>
            </label>
          </div>

          <!--EXPORT PREVIEWS-->
          <div class="dflex ml-2">
            <label :for="'previews' + $vnode.key" class="container"
            >{{ $t('pipeline.exportPreviews') }}
              <input
                  :id="'previews' + $vnode.key"
                  v-model="exportPreviews"
                  type="checkbox"
              >
              <span class="checkmark"/>
            </label>
          </div>

          <!--COMPLEXITY--->
          <div v-if="$store.getters.isSuperAdmin" class="form-item mt-3 mb-3">
            <label class="mb-5" for="lod">{{ $t('OverallComplexity') }}</label><br>
            <div v-if="isUpdate" class="previous-selection p-1">
              {{ $t('previousSelection') }}:
              {{ oldContentPipeline.complexity }}
            </div>
            <vue-slider
                v-model="localContentPipeline.complexity"
                :interval="1"
                :marks="complexityMarks"
                :max="10"
                :min="-10"
                :tooltip-formatter="formatComplexity"
                tooltip="always"
            >
            </vue-slider>
          </div>

          <!--UP-Axis--->
          <div v-if="$store.getters.isSuperAdmin" class="form-item mt-5 mb-4">
            <label class="low-margin-bottom vform-label white medium" for="upAxis">{{
                $t('upAxis')
              }}</label><br>
            <div v-if="isUpdate" class="previous-selection p-1">
              {{ $t('previousSelection') }}:
              {{ oldContentPipeline.upAxis }}
            </div>
            <selector
                ref="upAxisSelector"
                :pre-selected-value="localContentPipeline.upAxis"
                :values="['auto', 'x', 'y', 'z']"
                class="up-axis-selector"
                translation-prefix=""
                @setValue="(val) => {localContentPipeline.upAxis = val;}"/>
          </div>

          <!--UP-Axis--->
          <!--REGEX--->
          <div v-if="isUpdate">
            <label class="low-margin-bottom mt-3 vform-label white medium">{{ $t('useRegex') }}</label>
            <info-helper class="ml-1" text="useRegexInfo"/>
            <universal-selector
                :exclude-from-item-list="localContentPipeline.updateRegex ? localContentPipeline.updateRegex : []"
                list-name="importRegex"
                store-name="Regex"
                @addItem="addRegex"
            />
            <div v-for="regex in localContentPipeline.updateRegex"
                 v-if="localContent && localContentPipeline && localContentPipeline.updateRegex"
                 :key="regex.name"
            >
              <tag
                  :is-removable="true"
                  :tag="regex"
                  @removeTag="removeRegex"
              />
            </div>
          </div>
        </div>
      </info-panel>

      <!--PIVOT PLACEMENT--->
      <div class="form-item mt-3">
        <label class="low-margin-bottom vform-label white medium">{{ $t('pivotPlacement') }}</label>
        <info-helper class="ml-1" text="pivotComment"/>
        <div v-if="isUpdate" class="previous-selection p-1">
          {{ $t('previousSelection') }}:
          {{ oldContentPipeline.pivotPlacement }}
        </div>
        <selector
            ref="pivotSelector"
            :include-values="showAllPivotPositions ? [] : ['source', 'center']"
            :pre-selected-value="localContentPipeline.pivotPlacement"
            :values="pivotPositions"
            class="pivot-selector"
            translation-prefix="pivot."
            @setValue="(val) => {localContentPipeline.pivotPlacement = val;}"
        />
        <div v-if="!showAllPivotPositions" class="clickable" @click="showAllPivotPositions = true;">
          <i>{{ $t('showMorePivotPositions') }}</i></div>
        <div v-else>{{ $t('showingAllPivotsInDropdown') }}</div>
        <!--<select v-if="localContentReady" v-model="localContentPipeline.pivotPlacement" class="custom-select dark">
          <option v-if="showAllPivotPositions || ['source', 'center'].includes(key)" v-for="(key) in pivotPositions" :key="key" :value="key">{{ $t('pivot.' + key) }}</option>
        </select>-->
      </div>

      <!--LOD-LEVELS--->
      <div class="form-item mt-3">
        <label class="vform-label white medium mb-0" for="lod">{{ $t('LodLevels') }}
          (Lod)</label><br>
        <div v-if="isUpdate" class="previous-selection p-1">
          {{ $t('previousSelection') }}:
          {{ oldContentPipeline.lod }}
        </div>

        <selector
            ref="lodSelector"
            :pre-selected-value="localContentPipeline.lod"
            :values="[0,1,2,3]"
            class="lod-selector"
            translation-prefix="lodLevel."
            @setValue="(val) => {localContentPipeline.lod = parseInt(val);}"/>
      </div>


      <!--OUTPUT FORMATS--->
      <label class="mt-5 vform-label white medium mb-0" for="lod">{{ $t('OutputFormats') }}</label>
      <info-helper class="ml-1" text="outputFormatsHelp"/>

      <div class="form-item darker p-1 pt-3 border-radius">
        <div v-for="(item,index) in Object.keys(available3DOutputFormats)" :key="index">
          <div class="dflex ml-2">
            <label :for="item + $vnode.key" class="container"
            >{{ item }}
              <input
                  :id="item + $vnode.key"
                  v-model="selectedOutputFormats[item]"
                  :disabled="item === 'fbx'"
                  type="checkbox"
              >
              <span class="checkmark"/>
            </label>
          </div>
        </div>
      </div>
      <div class="w-100"/>


      <!--EMAIL--->
      <div>
        <label class="low-margin-bottom mt-3 vform-label white medium">{{ $t('email') }}</label>
        <info-helper class="ml-1" text="stepEmailDisclaimer"/>
        <div v-if="isUpdate" class="previous-selection p-1">
          {{ $t('previousSelection') }}:
          {{ oldContentPipeline.email }}
        </div>
        <input
            v-if="localContentReady"
            v-model="email"
            :class="['form-text form-text-dark bigger w-100', $v.email.$dirty && $v.email.$error ? 'form-group--error' : '']"
            type="text"
            @input="delayTouch($v.email)"
        >
        <div v-if="$v.email.$dirty && !$v.email.email" class="form-error mb-2">
          {{ $t('errors.mustBeAValidEmailAdress') }}
        </div>
      </div>

      <!--VM-->
      <label class="vform-label white medium mb-0 pb-0 mt-3">{{ $t('selectVM') }}</label>
      <vm-selector
          key="upper"
          :show-prices="false"
          custom-classes="darker"
          @selected="setVM"
      />

      <div class="w-100" />
      <hr class="separator" />

      <!--FILE-INFO-->
      <div v-if="localContentReady" class="col-12 mt-1 mb-2">
        <div class="row">
          <import-viewer
              :content="mixedContent"
          />
          <!--MESSAGES-->
          <div class="w-100 mt-3 mb-1 border-radius lighter">
            <span>{{ $t('Disclaimer') }}</span>: {{ $t('stepFileProcessingDisclaimer') }}
          </div>
          <div v-if="error" class="form-error">{{ error }}</div>

          <!--START TASK-->
          <div class="mt-3 settings-button action-button icon-rotate-animation make-longer-animation" :deactivated="!this.$v.email.email || partIdentifierColumnMissing"
                  @click="initiatePiplineFileProcessing">
            {{ $t('pipeline.importStart') }}
            <icon type="cube"/>
          </div>
          <!-- ABORT TASK -->
          <div class="mt-3 settings-button make-longer-animation switched-colors ml-1" :deactivated="!this.$v.email.email || partIdentifierColumnMissing"
               @click="$emit('abort')">
            {{ $t('pipeline.importAbort') }}
            <icon type="times"/>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  PivotPositions,
  TaskManagerTaskTypes,
  available3DOutputFormats,
  lodExport,
  extractComplexityLevels,
  RegexContexts
} from "@/enum";
import VuelidateMixin from "@/components/mixins/VuelidateMixin.js";
import vmSelector from "../vmSelector";
import {between, email} from "vuelidate/lib/validators";
import InfoHelper from "../InfoHelper";
import MetaConfig from "./MetaConfig";
import ImportViewer from "./ImportViewer";
import Icon from "../Icon";
import LoadingPanel from "../LoadingPanel";
import Selector from "../baseComponents/Selector";
import VueSlider from "vue-slider-component";
import InfoPanel from "../InfoPanel";
import {SpecialUuids} from "@/enum";
import UniversalSelector from "@/components/organizations/UniversalSelector.vue";
import Tag from "@/components/Tag.vue";

export default {
  name: "AssemblyImportConfig",
  components: {
    vmSelector,
    InfoHelper,
    MetaConfig,
    ImportViewer,
    Icon,
    LoadingPanel,
    Selector,
    VueSlider,
    InfoPanel,
    UniversalSelector,
    Tag
  },
  mixins: [VuelidateMixin],
  props: {
    /**
     * assetId {string} - the id of the assembly asset
     * */
    assetId: {type: String, required: true},
    organizationId: {type: String, required: true},
    /**
     * content {object} - the content field of the assembly asset
     * */
    content: {type: Object, required: true},
    /**
     * oldContent {object} - the content field of the assembly asset from a previous import (if available)
     * */
    oldContent: {
      type: Object, default: () => {
        return {}
      }
    },
    /**
     * hasRoot {boolean} - whether the assembly has a root node or not
     * (indicator whether something has already imported or not)
     * */
    hasRoot: {type: Boolean, default: false},
    teams: {
      type: Array, default: () => {
        return []
      }
    },
    pipelineStatus: {type: String, default: ""},
  },
  validations: {
    email: {
      email,
    },
    lod: {
      between: between(0, 5)
    }
  },
  data() {
    return {
      regexOptions: [],
      SpecialUuids: SpecialUuids,
      complexityMarks: {
        '-10': '1',
        '-5': '2',
        '0': '3',
        '5': '4',
        '10': '5'
      },
      showAllPivotPositions: false,
      vm: "",
      showLoading: false,
      buttonsDisabled: false,
      localContentReady: false,
      isProcessing: false,
      localContent: {},

      // pivots
      pivotPositions: PivotPositions,
      lodExport: lodExport,

      // output formats
      available3DOutputFormats: available3DOutputFormats,
      selectedOutputFormats: {"fbx": true, "glb": true},

      exportGroups: false,
      exportParts: false,
      exportPreviews: true,

      partIdentifierColumnMissing: true,

      error: "",

      TaskManagerTaskTypes: TaskManagerTaskTypes,
      metaDataColumns: [],

      hasRootFile: true,

      metaConfig: {},
      email: "",
    };
  },
  computed: {
    isUpdate() {
      return this.hasRoot;
    },
    localContentPipeline() {
      return this.localContent && this.localContent.pipeline ? this.localContent.pipeline : {};
    },
    oldContentPipeline() {
      return this.oldContent.pipeline ? this.oldContent.pipeline : {};
    },
    mixedContent() {
      const ob = JSON.parse(JSON.stringify(this.localContent));
      ob.pipeline = {...ob.pipeline, ...{
        email: this.email,
        outputFormats: Object.keys(this.selectedOutputFormats).filter(key => {
          return !!this.selectedOutputFormats[key]
        }),
      }}
      return ob;
    }
  },
  watch: {
    content: {
      deep: true,
      handler(content) {
        if (content.pipeline) {
          this.fixContent();

          const {pipeline} = content;
          const {sendMails, deleteExistingAssemblyParts, rootNodeFile, files} = pipeline;
          this.sendMails = sendMails !== undefined ? sendMails : true;
          this.deleteExistingAssemblyParts = deleteExistingAssemblyParts !== undefined ? deleteExistingAssemblyParts : false;
          if (rootNodeFile) {
            if (!(files.length === 1 && files[0].includes('.zip'))) {
              this.checkIfFileExists(rootNodeFile);
            }
          }
        }
      }
    }
  },
  beforeMount() {
    this.fixContent();
    this.checkAutoApplyingRegexes();
  },
  methods: {
    async checkAutoApplyingRegexes() {
      const metaValues = await this.$store.dispatch('clientLoadMetaValues', {
        id: SpecialUuids.REGEX_METASET,
        cid: SpecialUuids.CONTEXT_META_FIELD,
      });
      for (let i = 0; i < metaValues.length; i++) {
        let {value, targetId} = metaValues[i];
        let contexts;
        try {
          contexts = JSON.parse(value);
        } catch (e) {
          console.log('could not parse context object')
        }
        if (contexts) {
          const updateContext = contexts.find(item => {
            return item.realm === RegexContexts.SFX_UPDATE && item.autoApply === true;
          })
          if (updateContext) {
            const rgx = await this.$store.dispatch('loadRegex', {id: targetId});
            const {organizationId} = rgx;
            if (organizationId === this.organizationId) {
              this.addRegex(rgx);
            }
          }
        }
      }
    },
    removeRegex(item) {
      const {id} = item;
      const {updateRegex} = this.localContentPipeline;
      const index = updateRegex.findIndex(el => {
        return el.id === id;
      })
      if (index !== -1) {
        updateRegex.splice(index, 1);
      }
    },
    addRegex(item) {
      const {content, name, id} = item;
      if (!this.localContentPipeline.updateRegex) {
        this.localContentPipeline.updateRegex = [];
      }
      this.localContentPipeline.updateRegex.push({regex: content, name, id});
    },
    formatComplexity(val) {
      return extractComplexityLevels[val];
    },
    /**
     * Adds mandatory fields to the content field if missing
     * and sets default values because v-model doesn't work if a property is missing
     * */
    fixContent() {
      this.localContentReady = false;

      this.localContent = {
        pipeline: {
          lod: 2,
          upAxis: 'auto',
          complexity: -5,
          sendMails: true,
          email: this.$store.getters.getUserEmail(),
          pivotPlacement: 'source',
          deleteExistingAssemblyParts: false,
          updateRegex: [],
          ...this.content.pipeline
        },
      };
      this.email = this.localContentPipeline.email;
      if (this.localContentPipeline.meta && this.localContentPipeline.meta.columns) {
        this.metaDataColumns = this.localContentPipeline.meta.columns;
      } else {
        this.partIdentifierColumnMissing = false;
      }

      this.localContentReady = true;
    },

    /**
     * Checks if the root file in the content field exists
     * if it does not, remove the edit form to start the pipeline
     * */
    async checkIfFileExists(fileName) {
      await this.$store.dispatch('clientGetAssetInfo', {
        id: this.assetId,
        key: fileName
      }).catch(() => {
        this.hasRootFile = false;
      })
    },

    /**
     * Gathers necessary data for the content field, checks for errors
     * and starts the task if all is good
     * */
    async initiatePiplineFileProcessing() {
      this.error = '';
      this.buttonsDisabled = true;
      if (this.email) {
        if (!this.$v.email.email) {
          return;
        }
      }
      if (this.localContent) {
        const finalFormats = Object.keys(this.selectedOutputFormats)
            .filter(key => {
              return !!this.selectedOutputFormats[key]
            });
        // trigger saving the metaConfig so we have the current data
        if (this.$refs.MetaConfig) {
          await this.$refs.MetaConfig.save();
        }
        let currMeta = null;
        if (this.metaConfig && Object.keys(this.metaConfig).length) {
          currMeta = {clientMetaFile: this.localContentPipeline.meta.clientMetaFile, ...this.metaConfig};
        }
        this.localContent.pipeline = {
          status: 'cc: extract procedure initiated',
          ...this.localContentPipeline,
          user: this.$store.getters.getCurrentUserId,
          email: this.email ? this.email : this.$store.getters.getUserEmail(this.$store.getters.getCurrentUserId),
          outputFormats: finalFormats,
          exportGroups: this.exportGroups,
          exportParts: this.exportParts,
          exportPreviews: this.exportPreviews,
          meta: currMeta,
          showInitialForm: false,
          showUpdateForm: false,
        };

        this.isProcessing = true;
        await this.updateAssemblyContent();
        if (!this.error) {
          await this.startTask();
        }
      }
    },
    resetStatus() {
      this.content.pipeline.status = 'initiallyUploaded';
      this.$store.dispatch('updateAssembly', {
        id: this.assetId,
        content: JSON.stringify(this.content),
      });
      this.$store.dispatch('loadAssembly', {
        id: this.assetId,
        include: 'tags,metaSets'
      });
    },
    /**
     * Starts the pipeline task
     * if it has a root node: update
     * if it has no root node: extract (= initial import)
     * */
    async startTask() {
      this.buttonsDisabled = true;
      this.showLoading = true;
      this.$emit('startingTask');
      await this.$store.dispatch('clientAssetToPipeline', {
        id: this.assetId,
        type: this.hasRoot ? 'update' : 'extract',
        virtualMachine: this.vm,
        config: JSON.stringify({
          ...this.localContentPipeline,
          sendMails: true,
          email: this.email,
          lang: this.$i18n.locale ? this.$i18n.locale : 'en',
        })
      }).then(() => {
        this.$emit('taskStarted')
        this.showLoading = false;
      }).catch(res => {
        this.error = res.response.errors.message;
        this.isProcessing = false;
      })
    },
    /**
     * Starts a reImport task – only working if files are still fully extracted on VM
     * */
    reImport() {
      this.buttonsDisabled = true;
      this.$store.dispatch('clientAssetToPipeline', {
        id: this.assetId,
        type: 'reimport',
        virtualMachine: this.vm,
        config: JSON.stringify({
          sendMails: true,
          email: this.email,
          lang: this.$i18n.locale ? this.$i18n.locale : 'en'
        })
      }).catch(res => {
        this.error = res.response.errors.message;
        this.isProcessing = false;
      })
    },
    /**
     * Updates the content field of the asset
     * */
    async updateAssemblyContent() {
      return this.$store.dispatch('updateAssembly', {
        id: this.assetId,
        content: JSON.stringify(this.localContent),
      }).catch(e => {
        this.error = e;
      });
    },
    /**
     * Sets the to be used vm
     * */
    setVM(id) {
      this.vm = id;
    },
    /**
     * Sets the meta config for metadata import
     * */
    setMetaConfig(metaConfig) {
      this.metaConfig = metaConfig;
      this.partIdentifierColumnMissing = !this.metaConfig.partIdentifierColumn;
    },
  }
}
</script>

<style lang="scss" scoped>
.pivot-selector {
  z-index: 250;
  position: relative;
}

.previous-selection {
  background-color: rgba(0, 0, 0, 0.2);
  border-radius: 2px;
  margin-bottom: 3px;
  color: #a4a4a4;
}
.separator {
  background-color: transparent;
  color: transparent;
  border: none;
  border-bottom: 1px solid rgba(255,255,255,0.1);
}
</style>